module.exports = "//d2t2kh5dwcod2h.cloudfront.net/8e2c97ccb68c7a41208eeb282fb294e0b18a6972/images/cashRegistryDefaultSmall.webp";